import React from "react";

const WarningDialog = ({ isOpen, onClose, onSubmit, title, description = "", confirmText= "Confirm", cancelText = "Cancel"}) => {
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100"
      style={{zIndex:600}}
    >
      <div
        className=" space-y-2 bg-white rounded-lg shadow-xl p-6 w-full max-w-md"
        role="dialog"
        aria-modal="true"
        aria-labelledby="password-dialog-title"
        tabIndex={-1}
      >
        <h4>{title}</h4>
        <p>{description}</p>
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            { cancelText}
          </button>
          <button
            type="submit"
            onClick={onSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default WarningDialog;
